
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/integrations/supabase/client'
import { useToast } from '@/hooks/use-toast'
import OperatorLoginForm from '@/components/operator/OperatorLoginForm'

const OperatorLogin = () => {
  const navigate = useNavigate()
  const { toast } = useToast()

  useEffect(() => {
    // Check if operator is already logged in
    const checkSession = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession()
        console.log('Current session on operator login page:', session)
        
        if (session) {
          console.log('Session found, checking operator status for user:', session.user.id)
          
          // Check if user is an operator
          const { data: operator, error } = await supabase
            .from('operators')
            .select('*')
            .eq('user_id', session.user.id)
            .single()
          
          console.log('Operator check result:', { operator, error })
          
          if (operator) {
            console.log('Operator found, redirecting to dashboard')
            navigate('/operator/dashboard')
          } else if (error && error.code === 'PGRST116') {
            // No operator profile found, check if this should be an operator
            const isOperator = session.user.user_metadata?.is_operator
            const schoolId = session.user.user_metadata?.school_id
            const firstName = session.user.user_metadata?.first_name
            const lastName = session.user.user_metadata?.last_name
            
            console.log('No operator profile, checking metadata:', {
              isOperator,
              schoolId,
              firstName,
              lastName
            })
            
            if (isOperator && schoolId) {
              console.log('Creating missing operator profile for confirmed user')
              
              const { data: newOperator, error: createError } = await supabase
                .from('operators')
                .insert({
                  user_id: session.user.id,
                  school_id: schoolId,
                  email: session.user.email,
                  first_name: firstName,
                  last_name: lastName,
                })
                .select()
                .single()
              
              if (createError) {
                console.error('Failed to create operator profile:', createError)
                toast({
                  title: "Profile creation failed",
                  description: "Failed to complete operator account setup. Please contact support.",
                  variant: "destructive",
                })
                await supabase.auth.signOut()
              } else {
                console.log('Operator profile created successfully:', newOperator)
                toast({
                  title: "Account activated!",
                  description: "Your operator account has been successfully activated.",
                })
                navigate('/operator/dashboard')
              }
            } else {
              console.log('User does not have operator metadata, signing out')
              await supabase.auth.signOut()
            }
          } else {
            console.error('Error checking operator status:', error)
            await supabase.auth.signOut()
          }
        }
      } catch (error) {
        console.error('Session check error:', error)
      }
    }

    checkSession()
  }, [navigate, toast])

  return (
    <div className="min-h-screen flex items-center justify-center bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-green-900 via-green-800 to-green-950 p-6">
      <OperatorLoginForm />
    </div>
  )
}

export default OperatorLogin
